<template>
  <div :class="{ 'col-md-6 col-xl-4': isBlockView, 'col-md-12': !isBlockView }" class="list-view mb-2">
    <div class="card card-placeholder width--100per pl_c" :class="{ 'pl_c--block': isBlockView }">
      <div class="card-body py-2">
        <div class="pl_c--t pl_c--tl"></div>
        <div v-if="isBlockView" class="pl_c--t pl_c--tl"></div>
        <div v-if="isBlockView" class="pl_c--t pl_c--tl"></div>
        <div v-if="isBlockView" class="pl_c--t pl_c--tl"></div>
        <div v-if="isBlockView" class="pl_c--t pl_c--tl"></div>
        <div v-if="!isBlockView" class="pl_c--t"></div>
        <div v-if="!isBlockView" class="pl_c--t pl_c--tfw mt-4 mb-2"></div>
        <div v-if="!isBlockView" class="pl_c--t pl_c--tfw mb-2"></div>
        <div v-if="!isBlockView" class="pl_c--t pl_c--tl"></div>
        <div v-if="!isBlockView" class="pl_c--t pl_c--ts mt-4 mr-4 pull-left"></div>
        <div v-if="!isBlockView" class="pl_c--t pl_c--ts mt-4 pull-left"></div>
      </div>
      <div v-if="isBlockView" class="card-footer bg-white">
        <div class="pl_c--t"></div>
        <div class="pl_c--t"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'searchPlaceholder',
  props: {
    isBlockView: {
      type: Boolean,
      required: true
    }
  }
}
</script>
